import React, { useState } from "react";
import { Link, LinkPage } from "../types/Link";

interface LinkFormProps {
  onSubmit: (linkPage: LinkPage) => void;
  initialLinkPage?: LinkPage;
}

function toStub(s: string): string {
  return s.toLowerCase().replace(/[\s_]/g, "-");
}

const LinkForm: React.FC<LinkFormProps> = ({ onSubmit, initialLinkPage }) => {
  const [name, setName] = useState(initialLinkPage?.Name || "");
  const [description, setDescription] = useState(
    initialLinkPage?.Description || ""
  );
  const [links, setLinks] = useState(initialLinkPage?.Links || []);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onSubmit({
      Name: name,
      Stub: toStub(name),
      Description: description,
      Owner: null,
      Links: links,
    });
  };

  const addLink = () => {
    setLinks([
      ...links,
      { Name: "", URL: "", CreatedAt: new Date().toISOString() },
    ]);
  };

  const updateLink = (index: number, updatedLink: Link) => {
    setLinks(links.map((link, i) => (i === index ? updatedLink : link)));
  };

  const removeLink = (index: number) => {
    setLinks(links.filter((_, i) => i !== index));
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label htmlFor="name" className="block text-gray-700">
          Name:
        </label>
        <input
          type="text"
          id="name"
          value={name}
          onChange={(event) => setName(event.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
        />

        {name ? (
          <p className="text-s">
            Your page ID will be{" "}
            <span className="underline decoration-sky-500/30 m">
              {toStub(name)}
            </span>
          </p>
        ) : (
          <p className="text-s">&nbsp;</p>
        )}
      </div>

      <div>
        <label htmlFor="description" className="block text-gray-700">
          Description:
        </label>
        <textarea
          id="description"
          value={description}
          onChange={(event) => setDescription(event.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
        />
      </div>

      <h3 className="text-xl font-bold text-gray-700">Links</h3>
      {links.map((link, index) => (
        <div key={index} className="space-y-4">
          <div>
            <label
              htmlFor={`link-name-${index}`}
              className="block text-gray-700"
            >
              Link Name:
            </label>
            <input
              type="text"
              id={`link-name-${index}`}
              value={link.Name}
              onChange={(event) =>
                updateLink(index, { ...link, Name: event.target.value })
              }
              className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
            />
          </div>

          <div>
            <label
              htmlFor={`link-url-${index}`}
              className="block text-gray-700"
            >
              Link URL:
            </label>
            <input
              type="url"
              id={`link-url-${index}`}
              value={link.URL}
              onChange={(event) =>
                updateLink(index, { ...link, URL: event.target.value })
              }
              className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
            />
          </div>

          <button
            type="button"
            onClick={() => removeLink(index)}
            className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded"
          >
            Remove Link
          </button>
        </div>
      ))}
      <div className="columns-2 flex flex-row justify-between">
        <button
          type="button"
          onClick={addLink}
          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded mb-4"
        >
          Add Link
        </button>

        <button
          type="submit"
          className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded mb-4"
        >
          Submit
        </button>
      </div>
    </form>
  );
};

export default LinkForm;
